import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>
                <CheckboxInput
                    name="displayChart"
                    label={translate.gettext("Display chart")}
                    checked={settings.displayChart}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Display table")}
                    name="displayTable"
                    checked={settings.displayTable}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    name="displaySystemsWithoutSu"
                    label={translate.gettext("Systems without SU")}
                    checked={settings.displaySystemsWithoutSu}
                    onChange={this.handleChange.bind(this)}
                />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    name="displayName"
                    label={translate.gettext("Name")}
                    checked={settings.displayName}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayCategoryState"
                    label={translate.gettext("State")}
                    checked={settings.displayCategoryState}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayLastJobTime"
                    label={translate.gettext("Last job date")}
                    checked={settings.displayLastJobTime}
                    onChange={this.handleChange.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listSystems/Editor.tsx